import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail } from 'lucide-react';
import { languagePrefixes } from '../../../i18n';
import googleLogo from '../../../pages/authentication/google-logo.svg';
import { Button } from '../../ui/button';
import DealInvestorProfileList from '../../ui/dealInvestorProfileList';

function InvestorLastInvestments(props) {
  const { t, i18n } = useTranslation();
  const prefix = languagePrefixes[(i18n.language || 'en').split('-')[0]] || '';

  const action = (
    <Link to={`${prefix}/signup`}>
      <Button size="sm" className="flex items-center">
        <Mail className="h-4 w-4 mr-2" />
        <img src={googleLogo} alt="Google" className="h-4 w-4 mr-1" />
        {t('pageHome.content.t24')}
      </Button>
    </Link>
  );

  const mobileAction = (
    <Link to={`${prefix}/signup`} className="mt-3">
      <Button size="sm" className="flex items-center px-3 py-1.5 text-sm">
        <Mail className="h-4 w-4 mr-2" />
        <img src={googleLogo} alt="Google" className="h-4 w-4 mr-1" />
        {t('pageHome.content.t24')}
      </Button>
    </Link>
  );

  return (
    <DealInvestorProfileList
      {...props}
      surfaceKey="publicInvestorProfile"
      desktopAction={action}
      mobileAction={mobileAction}
    />
  );
}

export default InvestorLastInvestments;
